<script>
    import { onMount } from "svelte";
    import CalendarCategories from "../../Pages/CalendarCategories/CalendarCategories.svelte";
    import { user } from "../../stores";
    import { checkTokenExpiration } from "../../Utils/utilFunctions.svelte";

    export let params;
    export let tokenRefresh = undefined;
    
    onMount(async () => {
        tokenRefresh = checkTokenExpiration();
    });
</script>

{#await tokenRefresh then tokenRefreshResult}
    {#if (tokenRefreshResult === 'valid' || tokenRefreshResult === 'refreshed')}
        <div class="flex flex-1 flex-col w-full px-6 py-4 bg-gray-200">
            <CalendarCategories {params}  />
        </div>
    {/if}
{/await}